import {
  trigger,
  transition,
  animate,
  style,
  state,
} from '@angular/animations';

export const fadeInAnimation = trigger('fadeInAnimation', [
  state('show', style({ opacity: 1 })),
  state('hide', style({ opacity: 0 })),
  transition(':enter', [style({ opacity: 0 }), animate(500)]),
  transition('show => hide', [animate('1s')]),
  transition('hide => show', [animate('0.5s')]),
]);
